import { render } from "./Column202306.vue?vue&type=template&id=01ab7318&scoped=true"
import script from "./Column202306.vue?vue&type=script&lang=js"
export * from "./Column202306.vue?vue&type=script&lang=js"

import "./Column202306.vue?vue&type=style&index=0&id=01ab7318&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ab7318"]])

export default __exports__